<template>
    <v-app style="margin: -12px -12px -12px -12px;" data-aos-easing="ease" data-aos-duration="400" data-aos-delay="0" v-resize="onResize">
      <div v-if="false" class="d-flex ma-6" style="min-height: 30px;">
        <span class="ml-3" style="color: #4F4F4F;font-family: 'Montserrat';font-style: normal;font-weight: 500;align-self: center;max-width: 600px;font-size: 13px;line-height: 15px;letter-spacing: 0.01em;">{{initInfo.homeTextBlock1 ? initInfo.homeTextBlock1 : 'Данный сайт представляет собой Интернет-расширение информационной системы ДГТУ, созданное для студентов, их родителей и сотрудников университета.'}}</span>
        <v-spacer></v-spacer>
        <div class="text-xs-center" v-if="userFIO">
          <div v-if="isLogin">
            <v-btn v-if="!$vuetify.breakpoint.xs" :class="{ 'mx-0 px-0': $vuetify.breakpoint.xs }"
              class="textStyle"
              text
              style="text-transform: capitalize;font-weight: 600;font-size: 18px;"
              href="/WebApp/#/"
            >
              {{userFIO}}
            </v-btn>
          </div>
        </div>
        <!-- <v-text-field class="colorSoloText mb-0" color="#8C8C8C" prepend-inner-icon="fas fa-search" flat hide-details clearable dense style="border-radius: 12px;color:#8C8C8C" solo placeholder="Найти"></v-text-field> -->
        <v-btn v-if="isLogin" @click="logout()" class="textStyle ml-1 mt-1" color="#004992" small text><svgIcon class="mr-2" iconName="log-out" fill="#004992" :width="20" :height="20"></svgIcon>
          Выход
        </v-btn>
        <div v-else>
          <v-btn small text class="textStyle ml-1 mt-1" href="/WebApp/" style="font-family: 'Montserrat';
font-style: normal;font-weight: 600;font-size: 18px;line-height: 22px;">
            <svgIcon class="mr-2" iconName="log-in" fill="#004992" :width="20" :height="20"></svgIcon>
            Вход
          </v-btn>
        </div>
        <!-- <v-btn class="ml-1 mt-1" color="#004992" small text style="font-family: 'Montserrat';
font-style: normal;font-weight: 600;font-size: 18px;line-height: 22px;"><svgIcon class="mr-2" iconName="log-in" fill="#004992" :width="20" :height="20"></svgIcon> Вход</v-btn>
       -->
      </div>
      <section class="ma-6 d-flex pt-4 pb-6" style="justify-content: center;">
        <div style="display: inline-flex;align-items: center;">
          <v-img class="mr-4" style="width: 61.33px;height: 51px;" :src="baseUrl + 'img/icons/img/logoTitle.png'"/>
          <span class="textHeader1Nagel mr-3" style="color: #0644EE;font-weight: 500;">Студ ИСОиП</span>
          <span class="textHeader1Nagel" style="color: #0644EE;font-weight: 400;opacity: 0.5;">филиал ДГТУ в г. Шахты</span>
        </div>
      </section>
      <div class="" style="max-width: 1200px;margin: 0 auto;width: 100%;">
        <section class="ma-6 d-flex" style="justify-content: center;">
          <v-row style="justify-content: center;">
            <v-col cols="12" md="6" lg="6" class="mt-0">
              <v-card
                  style="height: 224px;background: #F0F4FD;overflow: hidden;border-radius: 24px;"
                  dark
                  elevation="0"
                  href="/WebApp/#/"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div v-if="!isLogin" class="ma-3" style="z-index: 1;">
                      <v-card-title class="textHeader1Nagel" style="color: #010A24;font-weight: 500;cursor:pointer;word-break: break-word;">Вход</v-card-title>
                      <v-card-subtitle style="color: #010A24;opacity: 0.6;font-size: 20px;line-height: 125%;">в личный кабинет</v-card-subtitle>
                    </div>
                  <div v-if="isLogin" class="ma-3" style="z-index: 1;">
                    <v-card-title class="textHeader1Nagel" style="color: #010A24;font-weight: 500;cursor:pointer;word-break: break-word;">В личный кабинет</v-card-title>
                  </div>
                    <v-avatar
                      class="ma-0"
                      tile
                      size="auto"
                      style="position: absolute;right: 0;"
                    >
                      <v-img class="mr-0" style="border-radius: 24.1818px;" :src="baseUrl + 'img/icons/img/login.png'"/>
                    </v-avatar>
                  </div>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" lg="6" class="mt-0">
              <v-card
                  style="height: 224px;background: #F0F4FD;overflow: hidden;border-radius: 24px;cursor:pointer;"
                  dark
                  elevation="0"
                  href="/WebApp/#/Rasp/List"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div class="ma-3" style="z-index: 1;">
                      <v-card-title class="textHeader1Nagel" style="color: #010A24;font-weight: 500;word-break: break-word;">Расписание</v-card-title>
                    </div>
                    <v-avatar
                      class="ma-0"
                      tile
                      size="auto"
                      style="position: absolute;right: 0;"
                    >
                      <v-img class="mr-0" style="border-radius: 24.1818px;" :src="baseUrl + 'img/icons/img/file.png'"/>
                    </v-avatar>
                  </div>
                </v-card>
            </v-col>
          </v-row>
        </section>
        <section v-if="isLogin" class="ma-6 d-flex ml-13 pt-6" style="">
          <span class="textHeader1Nagel">{{userFullName}}</span>
        </section>
        <section v-if="isLogin" class="ma-6 d-flex" style="justify-content: center;">
          <v-row v-if="cuser.userID > 0" style="">
            <v-col cols="12" md="3" lg="3" class="mt-0" v-for="(item) in items.myItems" :key="item.menuItemID">
              <v-card
                  style="height: 224px;background: #F0F4FD;overflow: hidden;border-radius: 24px;cursor:pointer;"
                  dark
                  elevation="0"
                  :href="item.href ? item.href : null"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div class="ma-3" style="z-index: 1;">
                      <v-card-title class="textHeader1Nagel pr-0 mb-1" style="color: #010A24;font-weight: 500;font-size: 26px;word-break: break-word;">{{item.text}}</v-card-title>
                      <v-card-subtitle v-if="item.description" class="pr-0" style="color: #010A24;opacity: 0.6;font-size: 20px;line-height: 125%;font-size: 16px;max-width:160px;">{{item.description}}</v-card-subtitle>
                    </div>
                    <v-avatar
                      class="ma-0"
                      tile
                      size="auto"
                      style="position: absolute;right: 0;bottom:0"
                    >
                      <v-img v-if="item.img" class="mr-0" :style="item.fullImg || 'width: 172px;height: 155px;'" :src="baseUrl + 'img/icons/img/' + item.img + '.png'"/>
                    </v-avatar>
                  </div>
                </v-card>
            </v-col>
            <v-col cols="12"  class="mt-0">
              <v-card
                  style="height: 64px;background: #F0F4FD;overflow: hidden;border-radius: 24px;cursor:pointer;"
                  dark
                  elevation="0"
                  @click="logout()"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div class="ma-3 mt-1" style="z-index: 1;">
                      <v-card-title class="textHeader1Nagel pr-0 mb-1" style="color: #010A24;font-weight: 500;font-size: 26px;word-break: break-word;">Выйти из личного кабинета</v-card-title>
                      <!-- <v-card-subtitle v-if="item.description" class="pr-0" style="color: #010A24;opacity: 0.6;font-size: 20px;line-height: 125%;font-size: 16px;max-width:160px;">{{item.description}}</v-card-subtitle> -->
                    </div>
                    <!-- <v-avatar
                      class="ma-0"
                      tile
                      size="auto"
                      style="position: absolute;right: 0;bottom:0"
                    >
                      <v-img v-if="item.img" class="mr-0" :style="item.fullImg || 'width: 172px;height: 155px;'" :src="baseUrl + 'img/icons/img/' + item.img + '.png'"/>
                    </v-avatar> -->
                  </div>
                </v-card>
            </v-col>
          </v-row>
        </section>
        <section v-if="directoryMenuItems.length > 0" class="ma-6 d-flex ml-13 pt-6" style="">
          <span class="textHeader1Nagel">Меню</span>
        </section>
        <section class="ma-6 d-flex" style="justify-content: center;">
          <v-row style="">
            <v-col cols="12" md="3" lg="3" class="mt-0" v-for="(item) in directoryMenuItems" :key="item.menuItemID">
              <v-card
                  style="height: 224px;background: #F0F4FD;overflow: hidden;border-radius: 24px;cursor:pointer;"
                  dark
                  elevation="0"
                  :href="item.href ? item.href : null"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div class="ma-3" style="z-index: 1;">
                      <v-card-title class="textHeader1Nagel pr-0 mb-1" style="color: #010A24;font-weight: 500;font-size: 26px;word-break: break-word;">{{item.text}}</v-card-title>
                      <v-card-subtitle v-if="item.description" class="pr-0" style="color: #010A24;opacity: 0.6;font-size: 20px;line-height: 125%;font-size: 16px;max-width:160px;">{{item.description}}</v-card-subtitle>
                    </div>
                    <v-avatar
                      class="ma-0"
                      tile
                      size="auto"
                      style="position: absolute;right: 0;bottom:0"
                    >
                      <v-img v-if="item.img" class="mr-0" :style="item.fullImg || 'width: 172px;height: 155px;'" :src="baseUrl + 'img/icons/img/' + item.img + '.png'"/>
                    </v-avatar>
                  </div>
                </v-card>
            </v-col>
            <!-- mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index <= 3)" :key="item.menuItemID" -->
          </v-row>
        </section>
        <section v-if="directoryItems.length > 0" class="ma-6 d-flex ml-13 pt-6" style="">
          <span class="textHeader1Nagel">Справочник</span>
        </section>
        <section class="ma-6 d-flex" style="justify-content: center;">
          <v-row style="">
            <!-- mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index <= 3)" :key="item.menuItemID" -->
            <v-col cols="12" md="3" lg="3" class="mt-0" v-for="(item) in directoryItems" :key="item.menuItemID">
              <v-card
                  style="height: 224px;background: #F0F4FD;overflow: hidden;border-radius: 24px;cursor:pointer;"
                  dark
                  elevation="0"
                  :href="item.href ? item.href : null"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div class="ma-3" style="z-index: 1;">
                      <v-card-title class="textHeader1Nagel pr-0 mb-1" style="color: #010A24;font-weight: 500;font-size: 26px;word-break: break-word;">{{item.text}}</v-card-title>
                      <v-card-subtitle v-if="item.description" class="pr-0" style="color: #010A24;opacity: 0.6;font-size: 20px;line-height: 125%;font-size: 16px;max-width:160px;">{{item.description}}</v-card-subtitle>
                    </div>
                    <v-avatar
                      class="ma-0"
                      tile
                      size="auto"
                      style="position: absolute;right: 0;bottom:0"
                    >
                      <v-img v-if="item.img" class="mr-0" :style="item.fullImg || 'width: 172px;height: 155px;'" :src="baseUrl + 'img/icons/img/' + item.img + '.png'"/>
                    </v-avatar>
                  </div>
                </v-card>
            </v-col>
          </v-row>
        </section>
        <section v-if="directoryMoresItems.length > 0" class="ma-6 d-flex ml-13 pt-6" style="">
          <span class="textHeader1Nagel">Ещё</span>
        </section>
        <section class="ma-6 d-flex" style="justify-content: center;">
          <v-row style="">
            <!-- mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index <= 3)" :key="item.menuItemID" -->
            <v-col cols="12" md="4" lg="4" class="mt-0" v-for="(item) in directoryMoresItems" :key="item.menuItemID">
              <v-card
                  style="height: 224px;background: #F0F4FD;overflow: hidden;border-radius: 24px;cursor:pointer;"
                  dark
                  elevation="0"
                  :href="item.href ? item.href : null"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div class="ma-3" style="z-index: 1;">
                      <v-card-title class="textHeader1Nagel pr-0 mb-1" style="color: #010A24;font-weight: 500;font-size: 26px;word-break: break-word;">{{item.text}}</v-card-title>
                      <v-card-subtitle v-if="item.description" class="pr-0" style="color: #010A24;opacity: 0.6;font-size: 20px;line-height: 125%;font-size: 16px;max-width:160px;">{{item.description}}</v-card-subtitle>
                    </div>
                    <v-avatar
                      class="ma-0"
                      tile
                      size="auto"
                      style="position: absolute;right: 0;bottom:0"
                    >
                      <v-img v-if="item.img" class="mr-0" :style="item.fullImg || 'width: 172px;height: 155px;'" :src="baseUrl + 'img/icons/img/' + item.img + '.png'"/>
                    </v-avatar>
                  </div>
                </v-card>
            </v-col>
          </v-row>
        </section>
        <section v-if="news.length > 0" class="ma-6 d-flex ml-13 pt-6" style="">
          <span class="textHeader1Nagel">Новости <span style="color: #0644EE;font-weight: 400;">{{news.length}}</span></span>
        </section>
        <section class="ma-6 d-flex">
          <div class="" style="width: 100%;">
            <v-row>
              <v-col cols="12" class="px-0">
                <div class="mt-0">
                  <v-carousel v-if="news.length > 0" hide-delimiters transition="fade-transition" interval="1000" class="carouselNews" style="min-height: 600px;height: 100%;">
                    <template v-for="(item, index) in news">
                      <v-carousel-item v-if="(index + 1) % columns === 1 || columns === 1" :key="index" style="min-height: 600px;">
                        <v-row class="flex-nowrap px-0" style="height:100%">
                            <template v-if="(+index) < news.length">
                              <v-col :key="iCol" v-for="(n,iCol) in columns" class="pa-5">
                                  <v-card v-if="(+index+ iCol) < news.length" min-height="550px" :light="!$vuetify.theme.dark" flat style="border: 2px solid #E1E9FD;border-radius: 14px;">
                                    <img
                                      :src="news[+index+ iCol].srcImg"
                                      onerror="this.onerror=null;this.src='https://edu.donstu.ru/img/news/newss.jpg';"
                                      style="position: relative;width: 100%;max-height: 100vh;background-size: cover;background-position: 50%;border-radius: 14px;"
                                    />
                                    <v-card-title class="textHeader1Nagel" style="word-break: break-word;font-size: 26px;">{{news[+index+ iCol].title}}</v-card-title>
                                    <v-card-text v-html="news[+index+ iCol].description" class="mb-6" style="font-family: 'Source Sans Pro';font-weight: 400;color: #010A24;"></v-card-text>
                                  </v-card>
                              </v-col>
                            </template>
                        </v-row>
                      </v-carousel-item>
                    </template>
                  </v-carousel>
                </div>
              </v-col>
            </v-row>
          </div>
        </section>
        <section class="ma-6 d-flex" style="justify-content: center;">
          <v-card elevation="0" class="pa-6" style="background: #F0F4FD;border-radius: 24px;max-width: 823px;">
            <div class="text-left textHeader1Nagel mb-3" style="color: #010A24;font-size: 48px;line-height: 100%;" :class="{'text-center' : isMobile, 'site-title': !isMobile, 'site-title-mobile': isMobile}">{{initInfo.homeTitul ? initInfo.homeTitul : 'Электронная информационно-образовательная среда ДГТУ'}}</div>
            <p v-if="!isMobile" class="textSounce" style="color: #010a24;font-size: 20px;font-weight: 400;max-width: 377px;line-height: 140%;" :class="{'text-center' : isMobile}">{{initInfo.homeTextBlock1 ? initInfo.homeTextBlock1 : 'Данный сайт представляет собой Интернет-расширение информационной системы ДГТУ, созданное для студентов, их родителей и сотрудников университета.'}}</p>
          </v-card>
        </section>
        <section class="ma-6 d-flex" style="justify-content: center;">
          <div style="text-align: center;">
            <p v-if="!isMobile" class="" style="font-family: 'Source Sans Pro';color: #0644EE;font-size: 20px;font-weight: 600;max-width: 377px;line-height: 125%;" :class="{'text-center' : isMobile}">Политика конфиденциальности</p>
            <p v-if="!isMobile" class="" style="font-family: 'Source Sans Pro';color: #0644EE;font-size: 20px;font-weight: 600;max-width: 377px;line-height: 125%;" :class="{'text-center' : isMobile}">Пользовательское соглашение</p>
            <p v-if="!isMobile" class="" style="font-family: 'Source Sans Pro';color: #0644EE;font-size: 20px;font-weight: 600;max-width: 377px;line-height: 125%;" :class="{'text-center' : isMobile}">Документы</p>
          </div>
        </section>
        <section class="ma-6 d-flex" style="justify-content: center;">
          <p v-if="!isMobile" class="" style="font-family: 'Source Sans Pro';color: #010a24;font-size: 20px;font-weight: 400;max-width: 377px;line-height: 125%;" :class="{'text-center' : isMobile}">© 2022–2023, Лаборатория MMIS</p>
        </section>
      </div>
      <!-- old -->
      <section v-if="false" class="home-section home-fade home-full-height bg-dark-60 landing-header parallax-bg aos-init" id="home" :style="'background-image: url(' + baseUrl + 'img/webapp/fonDgtu.jpg); min-height: '+ (isMobile ? 300 : 490) + 'px;'" v-intersect="onIntersectSection1">
        <div class="titan-caption" style="position: absolute;bottom: 0;">
          <div class="caption-content" style="position: relative;">
            <div class="container">
              <v-row :class="{'mt-16': !isMobile}">
                <!-- <v-col cols="12" lg="3">
                  <v-img
                    style="margin: 0 auto;"
                    max-height="500"
                    :max-width="isMobile ? 70 : 250"
                    :src="baseUrl + 'img/webapp/dstuWhite.png'"
                  ></v-img>
                </v-col> -->
                <!-- <v-col cols="12" lg="6" class="pa-5" :data-aos="!isMobile ? 'fade-left' : null" :class="{'aos-animate' : isIntersecting.section1, 'aos-init' : !isMobile}" >
                  <div class="mb-3">
                    <div class="text-left white--text mb-3" :class="{'text-center' : isMobile, 'site-title': !isMobile, 'site-title-mobile': isMobile}">Электронная информационно-образовательная среда ДГТУ</div>
                    <p v-if="!isMobile" class="white--text" style="font-size: 20px;font-weight: 400;" :class="{'text-center' : isMobile}">Данный сайт представляет собой Интернет-расширение информационной системы ДГТУ, созданное для студентов, их родителей и сотрудников университета.</p>
                  </div>
                  <div class="mt-8">
                    <v-btn
                      rounded
                      v-for="(item) in mainMenuItems" :key="item.menuItemID"
                      :color="'white'"
                      class="mr-6 mb-6 text--primary"
                      :class="{'ml-0' : isMobile}"
                      :href="item.href"
                      :target="item.newTab === true ? '_blank' : ''"
                      :small="isMobile"
                    >
                      {{item.text}}
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" class="ma-0 pa-5" :class="{'text-center' : isMobile}">
                  <div class="px-15 mt-2">

                  </div>
                </v-col> -->
                <v-col cols="12" lg="8" class="pa-5" :data-aos="!isMobile ? 'fade-left' : null" :class="{'aos-animate' : isIntersecting.section1, 'aos-init' : !isMobile}" >
                  <div class="mb-3">
                    <div class="ml-3 textSite text-left white--text mb-3" :class="{'site-title': !isMobile, 'site-title-mobile': isMobile}">{{initInfo.homeTitul ? initInfo.homeTitul : 'Электронная информационно-образовательная среда ДГТУ'}}</div>
                    <!-- <p v-if="!isMobile" class="white--text" style="font-size: 20px;font-weight: 400;" :class="{'text-center' : isMobile}">Данный сайт представляет собой Интернет-расширение информационной системы ДГТУ, созданное для студентов, их родителей и сотрудников университета.</p> -->
                  </div>
                  <div class="mt-8" v-if="false">
                    <v-btn
                      rounded
                      v-for="(item) in mainMenuItems" :key="item.menuItemID"
                      :color="'white'"
                      class="mr-6 mb-6 text--primary"
                      :class="{'ml-0' : isMobile}"
                      :href="item.href"
                      :target="item.newTab === true ? '_blank' : ''"
                      :small="isMobile"
                    >
                      {{item.text}}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </section>
      <section v-if="false" class="ma-6">
        <v-row>
          <v-col cols="12" lg="6" xl="4" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index <= 3).length > 0">
            <v-card class="pa-3" style="border-radius: 10px;height: 100%;">
              <v-card elevation="0">
                <v-row class="ml-0">
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pl-0 pr-3" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index <= 3)" :key="item.menuItemID">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="item.description !== null ? on: false" class="course" style="cursor:pointer" :href="item.href ? item.href : null" :target="item.newTab === true ? '_blank' : ''">
                          <div class="course-preview" :style="item.gradient ? 'background: linear-gradient(316.78deg,' + item.color + ' 18.63%,' + item.colorGradient + ' 77.82%);' : (item.color ? 'background:' + item.color + ';': '')" style="width: 75px;padding: 40px 20px;position: relative; background:linear-gradient(316.78deg, #2094ffb3, #033799b3);">
                            <h6 class="text-left d-flex" style="justify-content: center;">
                              <div class="mr-0" style="opacity: 1;">
                                <v-icon v-if="item.linkImg && item.linkImg.toLowerCase().startsWith('fa'.toLowerCase())" color="white">{{item.linkImg != null ? item.linkImg : 'fas fa-globe'}}</v-icon>
                                <svgIcon v-else-if="item.linkImg && item.linkImg.toLowerCase().startsWith('svg'.toLowerCase())" fill="#ffffff" :iconName="item.linkImg" :width="28" :height="24"></svgIcon>
                              </div>
                            </h6>
                          </div>
                          <div class="course-info" style="overflow: hidden;">
                            <h2 class="pr-2 pl-1 mb-3" style="font-family: 'Montserrat';font-style: normal;font-weight: 600;font-size: 18px;line-height: 24px;color: #004992;letter-spacing: 0.01em;max-width: 290px;">{{item.text}}</h2>
                            <div class="d-flex mt-1 ml-n1" style="position: absolute;bottom: 10px;margin-left: 1px !important;">
                            </div>
                          </div>
                        </v-card>
                      </template>
                      <span>{{item.description}}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </v-col>
          <v-col cols="12" lg="6" xl="4" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index > 3 && index <= 7).length > 0">
            <v-card class="pa-3" style="border-radius: 10px;height: 100%;">
              <v-card elevation="0">
                <v-row class="ml-0">
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pl-0 pr-3" v-for="(item) in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index > 3 && index <= 7)" :key="item.menuItemID">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="item.description !== null ? on: false" class="course" style="cursor:pointer" :href="item.href ? item.href : null" :target="item.newTab === true ? '_blank' : ''">
                          <div class="course-preview" :style="item.gradient ? 'background: linear-gradient(316.78deg,' + item.color + ' 18.63%,' + item.colorGradient + ' 77.82%);' : (item.color ? 'background:' + item.color + ';': '')" style="width: 75px;padding: 40px 20px;position: relative; background:linear-gradient(316.78deg, #2094ffb3, #033799b3);">
                            <h6 class="text-left d-flex" style="justify-content: center;">
                              <div class="mr-0" style="opacity: 1;">
                                <v-icon v-if="item.linkImg && item.linkImg.toLowerCase().startsWith('fa'.toLowerCase())" color="white">{{item.linkImg != null ? 'fas ' + item.linkImg : 'fas fa-globe'}}</v-icon>
                                <svgIcon v-else-if="item.linkImg && item.linkImg.toLowerCase().startsWith('svg'.toLowerCase())" :iconName="item.linkImg" fill="#ffffff" :width="28" :height="24"></svgIcon>
                              </div>
                            </h6>
                          </div>
                          <div class="course-info" style="overflow: hidden;">
                            <h2 class="pr-2 pl-1 mb-3" style="font-family: 'Montserrat';font-style: normal;font-weight: 600;font-size: 18px;line-height: 24px;color: #004992;letter-spacing: 0.01em;max-width: 290px;">{{item.text}}</h2>
                            <div class="d-flex mt-1 ml-n1" style="position: absolute;bottom: 10px;margin-left: 1px !important;">
                            </div>
                          </div>
                        </v-card>
                      </template>
                      <span>{{item.description}}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </v-col>
          <v-col cols="12" lg="6" xl="3" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index > 7 && index <= 9).length > 0">
            <v-card class="pa-3" style="border-radius: 10px; height: 100%;">
              <v-card elevation="0">
                <v-row class="ml-0">
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pl-0 pr-3" v-for="item in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index > 7 && index <= 9)" :key="item.menuItemID">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="item.description !== null ? on: false" class="course" style="cursor:pointer" :href="item.href ? item.href : null" :target="item.newTab === true ? '_blank' : ''">
                          <!-- @click="item.href ? $router.push(item.href) : true" -->
                          <div class="course-preview" :style="item.gradient ? 'background: linear-gradient(316.78deg,' + item.color + ' 18.63%,' + item.colorGradient + ' 77.82%);' : (item.color ? 'background:' + item.color + ';': '')" style="width: 75px;padding: 40px 20px;position: relative; background:linear-gradient(316.78deg, #2094ffb3, #033799b3);">
                            <h6 class="text-left d-flex" style="justify-content: center;">
                              <div class="mr-0" style="opacity: 1;">
                                <v-icon v-if="item.linkImg && item.linkImg.toLowerCase().startsWith('fa'.toLowerCase())" color="white">{{item.linkImg != null ? 'fas ' + item.linkImg : 'fas fa-globe'}}</v-icon>
                                <svgIcon v-else-if="item.linkImg && item.linkImg.toLowerCase().startsWith('svg'.toLowerCase())" :iconName="item.linkImg" fill="#ffffff" :width="28" :height="24"></svgIcon>
                              </div>
                            </h6>
                          </div>
                          <div class="course-info" style="overflow: hidden;">
                            <h2 class="pr-2 pl-1 mb-3" style="font-family: 'Montserrat';font-style: normal;font-weight: 600;font-size: 18px;line-height: 24px;color: #004992;letter-spacing: 0.01em;max-width: 290px;">{{item.text}}</h2>
                            <div class="d-flex mt-1 ml-n1" style="position: absolute;bottom: 10px;margin-left: 1px !important;">
                            </div>
                          </div>
                        </v-card>
                      </template>
                      <span>{{item.description}}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </v-col>
          <v-col cols="12" lg="6" xl="4" v-if="mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index > 9).length > 0">
              <v-card class="pa-3" style="border-radius: 10px; height: 100%;">
                <v-card elevation="0">
                  <v-row class="ml-0">
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pl-0 pr-3" v-for="item in mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index > 9)" :key="item.menuItemID">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-card v-bind="attrs" v-on="item.description !== null ? on: false" class="course" style="cursor:pointer" :href="item.href ? item.href : null" >
                            <!-- @click="item.href ? $router.push(item.href) : true" -->
                            <div class="course-preview" :style="item.gradient ? 'background: linear-gradient(316.78deg,' + item.color + ' 18.63%,' + item.colorGradient + ' 77.82%);' : (item.color ? 'background:' + item.color + ';': '')" style="width: 75px;padding: 40px 20px;position: relative; background:linear-gradient(316.78deg, #2094ffb3, #033799b3);">
                              <h6 class="text-left d-flex" style="justify-content: center;">
                                <div class="mr-0" style="opacity: 1;">
                                  <v-icon v-if="item.linkImg && item.linkImg.toLowerCase().startsWith('fa'.toLowerCase())" color="white">{{item.linkImg != null ? 'fas ' + item.linkImg : 'fas fa-globe'}}</v-icon>
                                  <svgIcon v-else-if="item.linkImg && item.linkImg.toLowerCase().startsWith('svg'.toLowerCase())" :iconName="item.linkImg" fill="#ffffff" :width="28" :height="24"></svgIcon>
                                </div>
                              </h6>
                            </div>
                            <div class="course-info" style="overflow: hidden;">
                              <h2 class="pr-2 pl-1 mb-3" style="font-family: 'Montserrat';font-style: normal;font-weight: 600;font-size: 18px;line-height: 24px;color: #004992;letter-spacing: 0.01em;max-width: 290px;">{{item.text}}</h2>
                              <div class="d-flex mt-1 ml-n1" style="position: absolute;bottom: 10px;margin-left: 1px !important;">
                              </div>
                            </div>
                          </v-card>
                        </template>
                        <span>{{item.description}}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>
          </v-col>
        </v-row>
      </section>
    </v-app>
</template>

<script>
import svgIcon from '@/components/ui/svgIcon'
import menu from '@/helpers/api/menu'
import news from '@/helpers/api/news'
import login from "@/helpers/api/login"
export default {
  name: 'MainPage',
  components: {
    svgIcon
  },
  data: () => ({
    mainMenuItems: [],
    directoryMenuItems: [],
    directoryItems: [],
    directoryMoresItems: [],
    news: [],
    isShowNews: false,
    items: {
      menus: [
        {menuItemID: 1, text: 'Графики', description: 'Учебные графики групп', img: 'graph', fullImg: true, href: '/Graph' },
        {menuItemID: 2, text: 'Оценки', description: 'Ведомости успеваемости', img: 'veds', fullImg: true, href: '/Ved'},
        {menuItemID: 3, text: 'Журналы', description: null, img: 'journal', fullImg: true, href: '/webapp/#/Journals/JournalList'},
        {menuItemID: 4, text: 'Курсы', description: null, img: 'courses', fullImg: true, href: '/WebApp/#/courses/list'},
        {menuItemID: 5, text: 'Учебные планы', description: null, img: 'plans', fullImg: true, href: '/Plans'},
        {menuItemID: 6, text: 'Статистика', description: null, img: 'stat', fullImg: true, href: '/Stat/Default.aspx?mode=statkaf'},
        {menuItemID: 7, text: 'Долги', description: 'Статистика задолженностей', img: 'debts', fullImg: true, href: '/stat/dolgfolder/dolgstudent.aspx'},
        {menuItemID: 8, text: 'КЭС', description: null, img: 'handbag', fullImg: true, href: '/КЭС'},
        {menuItemID: 9, text: 'Моё портфолио', description: null, img: 'champion', fullImg: true, href: '/webapp/#/Portfolio/ListWorks'},
        {menuItemID: 10, text: 'Сводные оценки', description: null, img: 'mark', fullImg: true, href: '/Totals/Default.aspx'},
        {menuItemID: 11, text: 'Тестирование', description: null, img: 'cloak', fullImg: true, href: 'https://webtest.sssu.ru'},
        {menuItemID: 12, text: 'Анкетирование ', description: null, img: 'questionnary', fullImg: true, href: '/WebApp/#/Questionnaires/List'},
      ],
      directory: [
        {menuItemID: 1, text: 'Факультеты', description: null, img: 'folders', fullImg: true},
        {menuItemID: 2, text: 'Группы', description: null, img: 'group', fullImg: true},
        {menuItemID: 3, text: 'Специальности', description: null, img: 'spets', fullImg: true},
        {menuItemID: 4, text: 'Преподаватели', description: null, img: 'teachers', fullImg: true},
      ],
      mores: [
        {menuItemID: 1, text: 'Обратная связь', description: null, img: 'tel', fullImg: true, href: '/webapp/#/feedback'},
        {menuItemID: 2, text: 'Библиотека', description: null, img: 'book', fullImg: true, href: '/Library/LibDiscipline.aspx'}
      ],
      myItems: [
        {menuItemID: 1, text: 'Поиск студента', description: null, img: 'search', fullImg: true, href: '/dek/Search.aspx'},
        {menuItemID: 2, text: 'Почта', description: null, img: 'email', fullImg: true, href: '/WebApp/#/mail/all'}
      ],
    },
    isIntersecting: {
      section1: false,
      section2: false,
      section3: true
    },
    isMobile: false
  }),
  methods: {
    logout () {
      window.getApp.$emit('APP_LOGOUT')
      // login.logOut()
    },
    onIntersectSection1 (entries) {
      if (this.isMobile) return true
      this.isIntersecting.section1 = entries[0].isIntersecting
    },
    onIntersectSection2 (entries) {
      if (this.isMobile) return true
      this.isIntersecting.section2 = entries[0].isIntersecting
    },
    onIntersectSection3 (entries) {
      if (this.isMobile) return true
      this.isIntersecting.section3 = entries[0].isIntersecting
    },
    onResize () {
      if (window.innerWidth < 900) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
  },
  computed: {
    userFIO () {
      return this.$store.getters.userFIO
    },
    userFullName () {
      return this.$store.getters.userFullName
    },
    isLogin () {
      return this.$store.getters.isLogin
    },
    initInfo () {
      return this.$store.state.initInfo
    },
    baseUrl () {
      return process.env.BASE_URL
    },
    columns () {
      if (this.$vuetify.breakpoint.xl) {
        return 3
      }
      if (this.$vuetify.breakpoint.lg) {
        return 3
      }
      if (this.$vuetify.breakpoint.md) {
        return 2
      }
      return 1
    },
    cuser () {
      return this.$store.getters.cuser
    },
    authenticated () {
      return this.$store.getters.authenticated
    }
  },
  async created () {
    let response = await news.getNews()
    this.news = response.news
    this.isShowNews = response.isShowNews
  },
  async mounted () {
    this.mainMenuItems = await menu.getMenuItems(1)
    this.directoryItems = await menu.getDirectoryItems()
    this.directoryMenuItems = await menu.getDirectoryMenuItems()
    this.directoryMoresItems = await menu.getDirectoryMoresItems()
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700&display=swap');
@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,500,600,700&display=swap');


@font-face {
  font-family: "Nagel Regular";
  src: url('/fonts/Nagel/Nagel_Regular.otf');
}
@font-face {
  font-family: "Nagel Bold";
  src: url('/fonts/Nagel/Nagel_Bold.otf');
}
@font-face {
  font-family: "Nagel Medium";
  src: url('/fonts/Nagel/Nagel_Medium.otf');
}
.textHeader1Nagel {
  font-family: 'Nagel Medium';
  font-style: normal;
  font-size: 42px;
  line-height: 95%;
}
.textHeader2Nagel {
  font-family: 'Nagel Medium';
  font-style: normal;
  font-size: 42px;
  line-height: 95%;
}
.textSounce {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 140%;
}
/* .textHeaderNagel {
  font-family: 'Nagel Medium';
  font-style: normal;
  line-height: 95%;
} */
.colorSoloText.v-text-field--solo>.v-input__control>.v-input__slot {
  background: #F2F2F2;
}
.textStyle {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #004992 !important;
}
.course {
  background-color: #fff;
  border-radius: 10px;
  /* box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2); */
  box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.2);
  display: flex !important;
  max-width: 100%;
  overflow: hidden;
  width: 700px;
  height: 100%;
  min-height: 120px !important;
}
.course h6 {
  /* opacity: 0.6; */
  margin: 0;
  text-align: left;
  text-transform: uppercase;
}

.course h2 {
  text-align: left;
  margin: 10px 0;
}

.course-preview {
  /* background-color: var(--v-stud-base) !important; */
  color: #fff;
  /* padding: 15px; */
  padding: 15px 10px;
  max-width: 250px;
}

.course-preview a {
  color: #fff !important;
  display: inline-block;
  font-size: 12px;
  opacity: 0.6;
  /* margin-top: 30px; */
  text-decoration: none;
}

.course-info {
  /* padding: 15px; */
  background: #F5F5F5;
  padding: 15px 10px;
  position: relative;
  width: 100%;
}
.textSite{
  letter-spacing: 0.03em;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 50px;
  text-transform: uppercase;
}
/*  */
.site-title {
  font-size: 30px;
  font-weight: 600;
}
.site-title-mobile {
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
}
.carouselNews .v-carousel__item{
  min-height: 600px !important;
  height: 100% !important;
}
</style>
<style scoped>
.home-section {
  position: relative;
  background-color: #fff;
  background-repeat: no-repeat;
  box-shadow: inset 0px -26px 89px rgb(13 26 62 / 70%);
  /* background-position: center center; */
  width: 100%;
  z-index: 0;
  background-size: cover;
}
.landing-header:before {
  position: absolute;
  background: linear-gradient(177.83deg, rgb(3 36 68 / 75%) 1.78%, rgb(4 89 218 / 10%) 98.18%);
  /* linear-gradient(177.83deg, rgb(3 36 68 / 75%) 1.78%, rgb(4 89 218 / 40%) 98.18%); */
  content: " ";
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
}
.font-alt {
  font-family: "Montserrat", "Roboto Condensed", sans-serif;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.module-medium {
  padding: 75px 0px;
}
.module-title {
  position: relative;
  letter-spacing: 2px;
  text-align: center;
  font-weight: 400;
  font-size: 30px;
  color: #111;
}
/* .module-title + .module-subtitle { */
  /* margin-top: -35px; */
/* } */
.module-subtitle {
  text-align: center;
  font-size: 16px;
  color: #111;
}
.large-text {
  font-size: 24px !important;
}
/* / */
/* .parallax-bg { */
  /* background-attachment: fixed; */
  /* background-size: cover; */
/* } */
.landing-reason:before {
  position: absolute;
  content: " ";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  /* background-color: rgb(36 58 81 / 92%); */
  background-color: rgb(31 64 98 / 92%);
}
.module,
.module-small {
  position: relative;
  padding: 140px 0;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
}

/* Module header */
.module-small {
  padding: 70px 0;
}

.module-extra-small {
  padding: 25px 0px;
}

.module-medium {
  padding: 75px 0px;
}

.holder-w {
  position: relative;
  display: table-cell;
  vertical-align: middle;
  height: 1px;
  width: 50%;
}

.holder-w:before {
  border-top: 1px solid #eaeaea;
  position: relative;
  display: block;
  content: "";
  top: 1px;
  height: 1px;
  width: 100%;
}
.landing-reason .module-title {
  /* color: #e6af4b; */
  color: #55e8ff;
}

/* .landing-reason .module-title + .module-subtitle { */
  /* margin-top: -60px; */
/* } */

.free-trial {
  background-color: rgba(88, 20, 158, 0.9);
  color: #FFFFFF;
}

.free-trial .color-golden {
  color: #e6af4b;
}


.landing-reason {
  color: #fff;
  font-size: 13px;
}

.landing-image-text {
  padding-top: 70px;
  padding-bottom: 0px;
}

.landing-image-text h2 {
  margin-top: 100px;
  margin-bottom: 15px;
}

.landing-screenshot:before {
  position: absolute;
  content: " ";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(66, 60, 130, 0.5);
}
/** */
@media (min-width: 1264px) {
  [data-aos][data-aos][data-aos-duration='50'],div[data-aos-duration='50'] [data-aos]{transition-duration:50ms}[data-aos][data-aos][data-aos-delay='50'],div[data-aos-delay='50'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='50'].aos-animate,div[data-aos-delay='50'] [data-aos].aos-animate{transition-delay:50ms}[data-aos][data-aos][data-aos-duration='100'],div[data-aos-duration='100'] [data-aos]{transition-duration:.1s}[data-aos][data-aos][data-aos-delay='100'],div[data-aos-delay='100'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='100'].aos-animate,div[data-aos-delay='100'] [data-aos].aos-animate{transition-delay:.1s}[data-aos][data-aos][data-aos-duration='150'],div[data-aos-duration='150'] [data-aos]{transition-duration:.15s}[data-aos][data-aos][data-aos-delay='150'],div[data-aos-delay='150'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='150'].aos-animate,div[data-aos-delay='150'] [data-aos].aos-animate{transition-delay:.15s}[data-aos][data-aos][data-aos-duration='200'],div[data-aos-duration='200'] [data-aos]{transition-duration:.2s}[data-aos][data-aos][data-aos-delay='200'],div[data-aos-delay='200'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='200'].aos-animate,div[data-aos-delay='200'] [data-aos].aos-animate{transition-delay:.2s}[data-aos][data-aos][data-aos-duration='250'],div[data-aos-duration='250'] [data-aos]{transition-duration:.25s}[data-aos][data-aos][data-aos-delay='250'],div[data-aos-delay='250'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='250'].aos-animate,div[data-aos-delay='250'] [data-aos].aos-animate{transition-delay:.25s}[data-aos][data-aos][data-aos-duration='300'],div[data-aos-duration='300'] [data-aos]{transition-duration:.3s}[data-aos][data-aos][data-aos-delay='300'],div[data-aos-delay='300'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='300'].aos-animate,div[data-aos-delay='300'] [data-aos].aos-animate{transition-delay:.3s}[data-aos][data-aos][data-aos-duration='350'],div[data-aos-duration='350'] [data-aos]{transition-duration:.35s}[data-aos][data-aos][data-aos-delay='350'],div[data-aos-delay='350'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='350'].aos-animate,div[data-aos-delay='350'] [data-aos].aos-animate{transition-delay:.35s}[data-aos][data-aos][data-aos-duration='400'],div[data-aos-duration='400'] [data-aos]{transition-duration:.4s}[data-aos][data-aos][data-aos-delay='400'],div[data-aos-delay='400'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='400'].aos-animate,div[data-aos-delay='400'] [data-aos].aos-animate{transition-delay:.4s}[data-aos][data-aos][data-aos-duration='450'],div[data-aos-duration='450'] [data-aos]{transition-duration:.45s}[data-aos][data-aos][data-aos-delay='450'],div[data-aos-delay='450'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='450'].aos-animate,div[data-aos-delay='450'] [data-aos].aos-animate{transition-delay:.45s}[data-aos][data-aos][data-aos-duration='500'],div[data-aos-duration='500'] [data-aos]{transition-duration:.5s}[data-aos][data-aos][data-aos-delay='500'],div[data-aos-delay='500'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='500'].aos-animate,div[data-aos-delay='500'] [data-aos].aos-animate{transition-delay:.5s}[data-aos][data-aos][data-aos-duration='550'],div[data-aos-duration='550'] [data-aos]{transition-duration:.55s}[data-aos][data-aos][data-aos-delay='550'],div[data-aos-delay='550'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='550'].aos-animate,div[data-aos-delay='550'] [data-aos].aos-animate{transition-delay:.55s}[data-aos][data-aos][data-aos-duration='600'],div[data-aos-duration='600'] [data-aos]{transition-duration:.6s}[data-aos][data-aos][data-aos-delay='600'],div[data-aos-delay='600'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='600'].aos-animate,div[data-aos-delay='600'] [data-aos].aos-animate{transition-delay:.6s}[data-aos][data-aos][data-aos-duration='650'],div[data-aos-duration='650'] [data-aos]{transition-duration:.65s}[data-aos][data-aos][data-aos-delay='650'],div[data-aos-delay='650'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='650'].aos-animate,div[data-aos-delay='650'] [data-aos].aos-animate{transition-delay:.65s}[data-aos][data-aos][data-aos-duration='700'],div[data-aos-duration='700'] [data-aos]{transition-duration:.7s}[data-aos][data-aos][data-aos-delay='700'],div[data-aos-delay='700'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='700'].aos-animate,div[data-aos-delay='700'] [data-aos].aos-animate{transition-delay:.7s}[data-aos][data-aos][data-aos-duration='750'],div[data-aos-duration='750'] [data-aos]{transition-duration:.75s}[data-aos][data-aos][data-aos-delay='750'],div[data-aos-delay='750'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='750'].aos-animate,div[data-aos-delay='750'] [data-aos].aos-animate{transition-delay:.75s}[data-aos][data-aos][data-aos-duration='800'],div[data-aos-duration='800'] [data-aos]{transition-duration:.8s}[data-aos][data-aos][data-aos-delay='800'],div[data-aos-delay='800'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='800'].aos-animate,div[data-aos-delay='800'] [data-aos].aos-animate{transition-delay:.8s}[data-aos][data-aos][data-aos-duration='850'],div[data-aos-duration='850'] [data-aos]{transition-duration:.85s}[data-aos][data-aos][data-aos-delay='850'],div[data-aos-delay='850'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='850'].aos-animate,div[data-aos-delay='850'] [data-aos].aos-animate{transition-delay:.85s}[data-aos][data-aos][data-aos-duration='900'],div[data-aos-duration='900'] [data-aos]{transition-duration:.9s}[data-aos][data-aos][data-aos-delay='900'],div[data-aos-delay='900'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='900'].aos-animate,div[data-aos-delay='900'] [data-aos].aos-animate{transition-delay:.9s}[data-aos][data-aos][data-aos-duration='950'],div[data-aos-duration='950'] [data-aos]{transition-duration:.95s}[data-aos][data-aos][data-aos-delay='950'],div[data-aos-delay='950'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='950'].aos-animate,div[data-aos-delay='950'] [data-aos].aos-animate{transition-delay:.95s}[data-aos][data-aos][data-aos-duration='1000'],div[data-aos-duration='1000'] [data-aos]{transition-duration:1s}[data-aos][data-aos][data-aos-delay='1000'],div[data-aos-delay='1000'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1000'].aos-animate,div[data-aos-delay='1000'] [data-aos].aos-animate{transition-delay:1s}[data-aos][data-aos][data-aos-duration='1050'],div[data-aos-duration='1050'] [data-aos]{transition-duration:1.05s}
[data-aos][data-aos][data-aos-delay='1050'],div[data-aos-delay='1050'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1050'].aos-animate,div[data-aos-delay='1050'] [data-aos].aos-animate{transition-delay:1.05s}[data-aos][data-aos][data-aos-duration='1100'],div[data-aos-duration='1100'] [data-aos]{transition-duration:1.1s}[data-aos][data-aos][data-aos-delay='1100'],div[data-aos-delay='1100'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1100'].aos-animate,div[data-aos-delay='1100'] [data-aos].aos-animate{transition-delay:1.1s}[data-aos][data-aos][data-aos-duration='1150'],div[data-aos-duration='1150'] [data-aos]{transition-duration:1.15s}[data-aos][data-aos][data-aos-delay='1150'],div[data-aos-delay='1150'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1150'].aos-animate,div[data-aos-delay='1150'] [data-aos].aos-animate{transition-delay:1.15s}[data-aos][data-aos][data-aos-duration='1200'],div[data-aos-duration='1200'] [data-aos]{transition-duration:1.2s}[data-aos][data-aos][data-aos-delay='1200'],div[data-aos-delay='1200'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1200'].aos-animate,div[data-aos-delay='1200'] [data-aos].aos-animate{transition-delay:1.2s}[data-aos][data-aos][data-aos-duration='1250'],div[data-aos-duration='1250'] [data-aos]{transition-duration:1.25s}[data-aos][data-aos][data-aos-delay='1250'],div[data-aos-delay='1250'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1250'].aos-animate,div[data-aos-delay='1250'] [data-aos].aos-animate{transition-delay:1.25s}[data-aos][data-aos][data-aos-duration='1300'],div[data-aos-duration='1300'] [data-aos]{transition-duration:1.3s}[data-aos][data-aos][data-aos-delay='1300'],div[data-aos-delay='1300'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1300'].aos-animate,div[data-aos-delay='1300'] [data-aos].aos-animate{transition-delay:1.3s}[data-aos][data-aos][data-aos-duration='1350'],div[data-aos-duration='1350'] [data-aos]{transition-duration:1.35s}[data-aos][data-aos][data-aos-delay='1350'],div[data-aos-delay='1350'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1350'].aos-animate,div[data-aos-delay='1350'] [data-aos].aos-animate{transition-delay:1.35s}[data-aos][data-aos][data-aos-duration='1400'],div[data-aos-duration='1400'] [data-aos]{transition-duration:1.4s}[data-aos][data-aos][data-aos-delay='1400'],div[data-aos-delay='1400'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1400'].aos-animate,div[data-aos-delay='1400'] [data-aos].aos-animate{transition-delay:1.4s}[data-aos][data-aos][data-aos-duration='1450'],div[data-aos-duration='1450'] [data-aos]{transition-duration:1.45s}[data-aos][data-aos][data-aos-delay='1450'],div[data-aos-delay='1450'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1450'].aos-animate,div[data-aos-delay='1450'] [data-aos].aos-animate{transition-delay:1.45s}[data-aos][data-aos][data-aos-duration='1500'],div[data-aos-duration='1500'] [data-aos]{transition-duration:1.5s}[data-aos][data-aos][data-aos-delay='1500'],div[data-aos-delay='1500'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1500'].aos-animate,div[data-aos-delay='1500'] [data-aos].aos-animate{transition-delay:1.5s}[data-aos][data-aos][data-aos-duration='1550'],div[data-aos-duration='1550'] [data-aos]{transition-duration:1.55s}[data-aos][data-aos][data-aos-delay='1550'],div[data-aos-delay='1550'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1550'].aos-animate,div[data-aos-delay='1550'] [data-aos].aos-animate{transition-delay:1.55s}[data-aos][data-aos][data-aos-duration='1600'],div[data-aos-duration='1600'] [data-aos]{transition-duration:1.6s}[data-aos][data-aos][data-aos-delay='1600'],div[data-aos-delay='1600'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1600'].aos-animate,div[data-aos-delay='1600'] [data-aos].aos-animate{transition-delay:1.6s}[data-aos][data-aos][data-aos-duration='1650'],div[data-aos-duration='1650'] [data-aos]{transition-duration:1.65s}[data-aos][data-aos][data-aos-delay='1650'],div[data-aos-delay='1650'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1650'].aos-animate,div[data-aos-delay='1650'] [data-aos].aos-animate{transition-delay:1.65s}[data-aos][data-aos][data-aos-duration='1700'],div[data-aos-duration='1700'] [data-aos]{transition-duration:1.7s}[data-aos][data-aos][data-aos-delay='1700'],div[data-aos-delay='1700'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1700'].aos-animate,div[data-aos-delay='1700'] [data-aos].aos-animate{transition-delay:1.7s}[data-aos][data-aos][data-aos-duration='1750'],div[data-aos-duration='1750'] [data-aos]{transition-duration:1.75s}[data-aos][data-aos][data-aos-delay='1750'],div[data-aos-delay='1750'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1750'].aos-animate,div[data-aos-delay='1750'] [data-aos].aos-animate{transition-delay:1.75s}[data-aos][data-aos][data-aos-duration='1800'],div[data-aos-duration='1800'] [data-aos]{transition-duration:1.8s}[data-aos][data-aos][data-aos-delay='1800'],div[data-aos-delay='1800'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1800'].aos-animate,div[data-aos-delay='1800'] [data-aos].aos-animate{transition-delay:1.8s}[data-aos][data-aos][data-aos-duration='1850'],div[data-aos-duration='1850'] [data-aos]{transition-duration:1.85s}[data-aos][data-aos][data-aos-delay='1850'],div[data-aos-delay='1850'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1850'].aos-animate,div[data-aos-delay='1850'] [data-aos].aos-animate{transition-delay:1.85s}[data-aos][data-aos][data-aos-duration='1900'],div[data-aos-duration='1900'] [data-aos]{transition-duration:1.9s}[data-aos][data-aos][data-aos-delay='1900'],div[data-aos-delay='1900'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1900'].aos-animate,div[data-aos-delay='1900'] [data-aos].aos-animate{transition-delay:1.9s}[data-aos][data-aos][data-aos-duration='1950'],div[data-aos-duration='1950'] [data-aos]{transition-duration:1.95s}[data-aos][data-aos][data-aos-delay='1950'],div[data-aos-delay='1950'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1950'].aos-animate,div[data-aos-delay='1950'] [data-aos].aos-animate{transition-delay:1.95s}[data-aos][data-aos][data-aos-duration='2000'],div[data-aos-duration='2000'] [data-aos]{transition-duration:2s}[data-aos][data-aos][data-aos-delay='2000'],div[data-aos-delay='2000'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2000'].aos-animate,div[data-aos-delay='2000'] [data-aos].aos-animate{transition-delay:2s}[data-aos][data-aos][data-aos-duration='2050'],div[data-aos-duration='2050'] [data-aos]{transition-duration:2.05s}[data-aos][data-aos][data-aos-delay='2050'],div[data-aos-delay='2050'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2050'].aos-animate,div[data-aos-delay='2050'] [data-aos].aos-animate{transition-delay:2.05s}[data-aos][data-aos][data-aos-duration='2100'],div[data-aos-duration='2100'] [data-aos]{transition-duration:2.1s}[data-aos][data-aos][data-aos-delay='2100'],div[data-aos-delay='2100'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2100'].aos-animate,div[data-aos-delay='2100'] [data-aos].aos-animate{transition-delay:2.1s}[data-aos][data-aos][data-aos-duration='2150'],div[data-aos-duration='2150'] [data-aos]{transition-duration:2.15s}[data-aos][data-aos][data-aos-delay='2150'],div[data-aos-delay='2150'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2150'].aos-animate,div[data-aos-delay='2150'] [data-aos].aos-animate{transition-delay:2.15s}[data-aos][data-aos][data-aos-duration='2200'],div[data-aos-duration='2200'] [data-aos]{transition-duration:2.2s}[data-aos][data-aos][data-aos-delay='2200'],div[data-aos-delay='2200'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2200'].aos-animate,div[data-aos-delay='2200'] [data-aos].aos-animate{transition-delay:2.2s}[data-aos][data-aos][data-aos-duration='2250'],div[data-aos-duration='2250'] [data-aos]{transition-duration:2.25s}[data-aos][data-aos][data-aos-delay='2250'],div[data-aos-delay='2250'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2250'].aos-animate,div[data-aos-delay='2250'] [data-aos].aos-animate{transition-delay:2.25s}[data-aos][data-aos][data-aos-duration='2300'],div[data-aos-duration='2300'] [data-aos]{transition-duration:2.3s}[data-aos][data-aos][data-aos-delay='2300'],div[data-aos-delay='2300'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2300'].aos-animate,div[data-aos-delay='2300'] [data-aos].aos-animate{transition-delay:2.3s}[data-aos][data-aos][data-aos-duration='2350'],div[data-aos-duration='2350'] [data-aos]{transition-duration:2.35s}[data-aos][data-aos][data-aos-delay='2350'],div[data-aos-delay='2350'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2350'].aos-animate,div[data-aos-delay='2350'] [data-aos].aos-animate{transition-delay:2.35s}[data-aos][data-aos][data-aos-duration='2400'],div[data-aos-duration='2400'] [data-aos]{transition-duration:2.4s}[data-aos][data-aos][data-aos-delay='2400'],div[data-aos-delay='2400'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2400'].aos-animate,div[data-aos-delay='2400'] [data-aos].aos-animate{transition-delay:2.4s}[data-aos][data-aos][data-aos-duration='2450'],div[data-aos-duration='2450'] [data-aos]{transition-duration:2.45s}[data-aos][data-aos][data-aos-delay='2450'],div[data-aos-delay='2450'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2450'].aos-animate,div[data-aos-delay='2450'] [data-aos].aos-animate{transition-delay:2.45s}[data-aos][data-aos][data-aos-duration='2500'],div[data-aos-duration='2500'] [data-aos]{transition-duration:2.5s}[data-aos][data-aos][data-aos-delay='2500'],
div[data-aos-delay='2500'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2500'].aos-animate,div[data-aos-delay='2500'] [data-aos].aos-animate{transition-delay:2.5s}[data-aos][data-aos][data-aos-duration='2550'],div[data-aos-duration='2550'] [data-aos]{transition-duration:2.55s}[data-aos][data-aos][data-aos-delay='2550'],div[data-aos-delay='2550'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2550'].aos-animate,div[data-aos-delay='2550'] [data-aos].aos-animate{transition-delay:2.55s}[data-aos][data-aos][data-aos-duration='2600'],div[data-aos-duration='2600'] [data-aos]{transition-duration:2.6s}[data-aos][data-aos][data-aos-delay='2600'],div[data-aos-delay='2600'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2600'].aos-animate,div[data-aos-delay='2600'] [data-aos].aos-animate{transition-delay:2.6s}[data-aos][data-aos][data-aos-duration='2650'],div[data-aos-duration='2650'] [data-aos]{transition-duration:2.65s}[data-aos][data-aos][data-aos-delay='2650'],div[data-aos-delay='2650'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2650'].aos-animate,div[data-aos-delay='2650'] [data-aos].aos-animate{transition-delay:2.65s}[data-aos][data-aos][data-aos-duration='2700'],div[data-aos-duration='2700'] [data-aos]{transition-duration:2.7s}[data-aos][data-aos][data-aos-delay='2700'],div[data-aos-delay='2700'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2700'].aos-animate,div[data-aos-delay='2700'] [data-aos].aos-animate{transition-delay:2.7s}[data-aos][data-aos][data-aos-duration='2750'],div[data-aos-duration='2750'] [data-aos]{transition-duration:2.75s}[data-aos][data-aos][data-aos-delay='2750'],div[data-aos-delay='2750'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2750'].aos-animate,div[data-aos-delay='2750'] [data-aos].aos-animate{transition-delay:2.75s}[data-aos][data-aos][data-aos-duration='2800'],div[data-aos-duration='2800'] [data-aos]{transition-duration:2.8s}[data-aos][data-aos][data-aos-delay='2800'],div[data-aos-delay='2800'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2800'].aos-animate,div[data-aos-delay='2800'] [data-aos].aos-animate{transition-delay:2.8s}[data-aos][data-aos][data-aos-duration='2850'],div[data-aos-duration='2850'] [data-aos]{transition-duration:2.85s}[data-aos][data-aos][data-aos-delay='2850'],div[data-aos-delay='2850'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2850'].aos-animate,div[data-aos-delay='2850'] [data-aos].aos-animate{transition-delay:2.85s}[data-aos][data-aos][data-aos-duration='2900'],div[data-aos-duration='2900'] [data-aos]{transition-duration:2.9s}[data-aos][data-aos][data-aos-delay='2900'],div[data-aos-delay='2900'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2900'].aos-animate,div[data-aos-delay='2900'] [data-aos].aos-animate{transition-delay:2.9s}[data-aos][data-aos][data-aos-duration='2950'],div[data-aos-duration='2950'] [data-aos]{transition-duration:2.95s}[data-aos][data-aos][data-aos-delay='2950'],div[data-aos-delay='2950'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2950'].aos-animate,div[data-aos-delay='2950'] [data-aos].aos-animate{transition-delay:2.95s}[data-aos][data-aos][data-aos-duration='3000'],div[data-aos-duration='3000'] [data-aos]{transition-duration:3s}[data-aos][data-aos][data-aos-delay='3000'],div[data-aos-delay='3000'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='3000'].aos-animate,div[data-aos-delay='3000'] [data-aos].aos-animate{transition-delay:3s}[data-aos][data-aos][data-aos-easing=linear],div[data-aos-easing=linear] [data-aos]{transition-timing-function:cubic-bezier(.25,.25,.75,.75)}[data-aos][data-aos][data-aos-easing=ease],div[data-aos-easing=ease] [data-aos]{transition-timing-function:ease}[data-aos][data-aos][data-aos-easing=ease-in],div[data-aos-easing=ease-in] [data-aos]{transition-timing-function:ease-in}[data-aos][data-aos][data-aos-easing=ease-out],div[data-aos-easing=ease-out] [data-aos]{transition-timing-function:ease-out}[data-aos][data-aos][data-aos-easing=ease-in-out],div[data-aos-easing=ease-in-out] [data-aos]{transition-timing-function:ease-in-out}[data-aos][data-aos][data-aos-easing=ease-in-back],div[data-aos-easing=ease-in-back] [data-aos]{transition-timing-function:cubic-bezier(.6,-.28,.735,.045)}[data-aos][data-aos][data-aos-easing=ease-out-back],div[data-aos-easing=ease-out-back] [data-aos]{transition-timing-function:cubic-bezier(.175,.885,.32,1.275)}[data-aos][data-aos][data-aos-easing=ease-in-out-back],div[data-aos-easing=ease-in-out-back] [data-aos]{transition-timing-function:cubic-bezier(.68,-.55,.265,1.55)}[data-aos][data-aos][data-aos-easing=ease-in-sine],div[data-aos-easing=ease-in-sine] [data-aos]{transition-timing-function:cubic-bezier(.47,0,.745,.715)}[data-aos][data-aos][data-aos-easing=ease-out-sine],div[data-aos-easing=ease-out-sine] [data-aos]{transition-timing-function:cubic-bezier(.39,.575,.565,1)}[data-aos][data-aos][data-aos-easing=ease-in-out-sine],div[data-aos-easing=ease-in-out-sine] [data-aos]{transition-timing-function:cubic-bezier(.445,.05,.55,.95)}[data-aos][data-aos][data-aos-easing=ease-in-quad],div[data-aos-easing=ease-in-quad] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-quad],div[data-aos-easing=ease-out-quad] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-quad],div[data-aos-easing=ease-in-out-quad] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos][data-aos][data-aos-easing=ease-in-cubic],div[data-aos-easing=ease-in-cubic] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-cubic],div[data-aos-easing=ease-out-cubic] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-cubic],div[data-aos-easing=ease-in-out-cubic] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos][data-aos][data-aos-easing=ease-in-quart],div[data-aos-easing=ease-in-quart] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-quart],div[data-aos-easing=ease-out-quart] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-quart],div[data-aos-easing=ease-in-out-quart] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos^=fade][data-aos^=fade]{opacity:0;transition-property:opacity,transform}[data-aos^=fade][data-aos^=fade].aos-animate{opacity:1;transform:translate(0)}[data-aos=fade-up]{transform:translateY(100px)}[data-aos=fade-down]{transform:translateY(-100px)}
[data-aos=fade-right]{transform:translate(-100px)}
[data-aos=fade-left]{transform:translate(-100px)  }
[data-aos=fade-up-right]{transform:translate(-100px,100px)}
[data-aos=fade-up-left]{transform:translate(100px,100px)}
[data-aos=fade-down-right]{transform:translate(-100px,-100px)}
[data-aos=fade-down-left]{transform:translate(100px,-100px)}
[data-aos^=zoom][data-aos^=zoom]{opacity:0;transition-property:opacity,transform}[data-aos^=zoom][data-aos^=zoom]
.aos-animate{opacity:1;transform:translate(0) scale(1)}
[data-aos=zoom-in]{transform:scale(.6)}[data-aos=zoom-in-up]{transform:translateY(100px) scale(.6)}[data-aos=zoom-in-down]{transform:translateY(-100px) scale(.6)}
[data-aos=zoom-in-right]{transform:translate(-100px) scale(.6)}[data-aos=zoom-in-left]{transform:translate(100px) scale(.6)}[data-aos=zoom-out]{transform:scale(1.2)}
[data-aos=zoom-out-up]{transform:translateY(100px) scale(1.2)}[data-aos=zoom-out-down]{transform:translateY(-100px) scale(1.2)}
[data-aos=zoom-out-right]{transform:translate(-100px) scale(1.2)}[data-aos=zoom-out-left]{transform:translate(100px) scale(1.2)}
[data-aos^=slide][data-aos^=slide]{transition-property:transform}[data-aos^=slide][data-aos^=slide].aos-animate{transform:translate(0)}
[data-aos=slide-up]{transform:translateY(100%)}[data-aos=slide-down]{transform:translateY(-100%)}[data-aos=slide-right]{transform:translateX(-100%)}[data-aos=slide-left]{transform:translateX(100%)}[data-aos^=flip][data-aos^=flip]{backface-visibility:hidden;transition-property:transform}[data-aos=flip-left]{transform:perspective(2500px) rotateY(-100deg)}[data-aos=flip-left].aos-animate{transform:perspective(2500px) rotateY(0)}[data-aos=flip-right]{transform:perspective(2500px) rotateY(100deg)}[data-aos=flip-right].aos-animate{transform:perspective(2500px) rotateY(0)}[data-aos=flip-up]{transform:perspective(2500px) rotateX(-100deg)}[data-aos=flip-up].aos-animate{transform:perspective(2500px) rotateX(0)}[data-aos=flip-down]{transform:perspective(2500px) rotateX(100deg)}[data-aos=flip-down].aos-animate{transform:perspective(2500px) rotateX(0)}
/*# animate aos.css*/

}
</style>
